export const Fonts = {
    AkkuratFont: "'Akkuratlltt', serif",
    VictorFont: "'VictorSerif', sans-serif",
    VictorItalicFont: "'VictorSerifItalic', 'VictorSerif', sans-serif"
}

export const Colors = {
    black: '#000'
}
